import React from 'react'
import _ from 'lodash'

import {Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

import {Alert, Button, Icon, Menu, Modal} from 'antd'

import {SelectedACL} from './SelectedACL.jsx'
import {AddACL} from './AddACL.jsx'

import {OrganizationsStorage, NetworksStorage} from 'storage'
import {OrganizationStore} from 'api/organization'

import {AuthStore} from 'api/auth'

const Entity = ({type, ent, resource}) => {
   if (resource === (AuthStore.auth || {}).owner) {
      return (
         <span>
            <b>
               <Icon type="user" />
               &nbsp;&nbsp;&nbsp;
               You
            </b>
         </span>
      )
   } else if ('organization' === type) {
      return (
         <span>
            <Icon type="team" />
            &nbsp;&nbsp;&nbsp;
            {(OrganizationStore.organization(ent) || {}).name || ent}
         </span>
      )
   }

   return (
      <span>
         <Icon type="user" />
         &nbsp;&nbsp;&nbsp;
         {ent}
      </span>
   )
}

Entity.propTypes = {
   type:     React.PropTypes.string.isRequired,
   ent:      React.PropTypes.string.isRequired,
   resource: React.PropTypes.string.isRequired
}

export class ACL extends React.Component {
   static get propTypes() {
      return {
         network:  React.PropTypes.object.isRequired,
         children: React.PropTypes.node,
         params:   React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         network: {}
      }
   }

   constructor() {
      super()

      this.state = {
         aclModal: false
      }

      this.toggleAclModal = this.toggleAclModal.bind(this)
   }

   toggleAclModal(ev) {
      this.setState(state => _.set(state, 'aclModal', !state.aclModal))
   }

   render() {
      const {children, location, routes, network, ...props} = this.props,
         {key, parents} = network,
         basepath = _.dropRightWhile(location.pathname.split('/'), p => 'acl' !== p).join('/')

      return (
         <div className="acl">
            <Row>
               <Col xs={4} className="sidebar">
                  <Menu selectedKeys={[location.pathname]}>
                     {_.map(parents, (ent, idx) => {
                        let [type, ...res] = ent.split('/')

                        return (
                           <Menu.Item key={`${basepath}/policy/${ent}`}>
                              <Link to={{pathname: `${basepath}/policy/${ent}`}}>
                                 <Entity resource={ent} type={type} ent={res.join('/')} />
                              </Link>
                           </Menu.Item>
                        )
                     })}

                     <Menu.Divider />

                     <Menu.Item key={`${basepath}/create`}>
                        <Link to={{pathname: basepath + '/create'}}>
                           <Icon type="plus" /> Add New Policy
                        </Link>
                     </Menu.Item>

                     {location.pathname === `${basepath}/create`
                        ? <Menu.Item key={basepath}>
                             <Link to={{pathname: basepath}}>
                                <Icon type="rollback" /> Go Back
                             </Link>
                          </Menu.Item>
                        : null}

                  </Menu>
               </Col>

               <Col xs={8}>
                  <OrganizationsStorage>
                     {children
                        ? React.cloneElement(children, {...props, network, location, routes, props})
                        : <NotSelected location={location} network={network} {...props} />}
                  </OrganizationsStorage>
               </Col>
            </Row>
         </div>
      )
   }
}

const NotSelected = props => {
   return (
      <div>
         <div className="page-header">
            <h1>Permissions</h1>
         </div>

         <RevokedAlert {...props} />

         <p className="lead">
            Here you can control which entities have access to this network.
         </p>

         <p>
            Use the menu on the left to add new policies or revoke existing ones.
         </p>
      </div>
   )
}

const RevokedAlert = ({location, network}) => {
   let ent = _.get(location, 'query.revoked', null),
      entInNetwork = -1 !== _.indexOf(network.parents, ent)

   if (ent && !entInNetwork) {
      return (
         <Alert
            type="warning"
            title="Policies Revoked"
            showIcon
            description={
               <p>
                  Access policies for <em>{ent}</em> was revoked
               </p>
            }
         />
      )
   } else {
      return null
   }
}

RevokedAlert.propTypes = {
   params:  React.PropTypes.object.isRequired,
   network: React.PropTypes.object.isRequired
}

ACL.childRoutes = [
   {
      path:      'create',
      component: AddACL
   },
   {
      path:      'policy/*',
      component: SelectedACL
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/acl/index.js